$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('scenario-rv-product')) {
    customElements.define(
      'scenario-rv-product',
      class ScenarioRvProduct extends HTMLElement {
        productDetailModalBigPictrueSwiper = null;
        productDetailModalSmallPictrueSwiper = null;
        shopMoneyFormat = null;
        productInventoryQuantity = null;
        productDetailModalCopy = null;
        swiper = null;
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
          this.initFilter();
          this.initPcFilterItemEvent();
          this.initMobileFilterItemEvent();
          this.initShowMore();
          this.initDrawer();
          this.initProductGrid();
        }

        onSubmitHandler(id = 'CollectionFiltersForm') {
          const formData = new FormData(this.querySelector(`#${id}`));
          const searchParams = new URLSearchParams(formData).toString();

          // 获取当前 URL 的所有参数
          const currentUrlParams = new URLSearchParams(window.location.search);
          const qParam = currentUrlParams.get('q');
          const typeParam = currentUrlParams.get('type');
          const sortByParam = currentUrlParams.get('sort_by');

          // 构建新的 URL
          let url = `${window.location.pathname}?${searchParams}`;

          // 添加需要保留的参数
          if (qParam) {
            url += `&q=${qParam}`;
          }
          if (typeParam) {
            url += `&type=${typeParam}`;
          }
          if (sortByParam) {
            url += `&sort_by=${sortByParam}`;
          }

          // 去除page参数
          url = url.replace(/page=\d+/, '');

          // 更细地址参数
          window.history.pushState({}, '', url);
          this.renderSectionFromFetch(url);
        }

        renderSectionFromFetch(url) {
          const _this = this;
          window.litime.showLoading();

          fetch(url)
            .then((response) => {
              if (response.status === 200) {
                return response.text();
              } else {
                throw new Error('Network response was not ok');
              }
            })
            .then((responseText) => {
              const html = responseText;
              if (html) {
                _this.renderProductGrid(html);
              }
              window.litime.hideLoading();
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
              window.litime.hideLoading();
            });
        }

        renderProductGrid(html) {
          const innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionRvProductGrid')?.innerHTML;
          this.querySelector('#CollectionRvProductGrid').innerHTML = innerHTML;
          const filterCount = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('filter-pc_count')?.innerHTML;
          this.querySelector('#filter-pc_count').innerHTML = filterCount;

          // const filterCountMobile = new DOMParser()
          //   .parseFromString(html, 'text/html')
          //   .getElementById('filter_count_mobile')?.innerHTML;
          // this.querySelector('#filter_count_mobile').innerHTML = filterCountMobile;

          const globalTabContainer = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('global-tab_container')?.innerHTML;
          this.querySelector('#global-tab_container').innerHTML = globalTabContainer;

          const sortByContainer = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('sort-by-container')?.innerHTML;
          this.querySelector('#sort-by-container').innerHTML = sortByContainer;

          const CollectionFiltersForm = this.querySelector('#CollectionFiltersForm');
          const mobileFilterForm = this.querySelector('#mobile-filter-form_wrapper');

          const CollectionFiltersFormInnerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionFiltersForm')?.innerHTML;
          CollectionFiltersForm.innerHTML = CollectionFiltersFormInnerHTML;

          const mobileFilterFormInnerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('mobile-filter-form_wrapper')?.innerHTML;
          mobileFilterForm.innerHTML = mobileFilterFormInnerHTML;

          this.removeInputEvent();

          this.init();
          this.initFilter();
          this.initMobileFilterItemEvent();
          this.initPcFilterItemEvent();
          this.initShowMore();
          this.initDrawer();
          this.initProductGrid();
          if (typeof fetchInitCompare === 'function') {
            fetchInitCompare();
          }
        }

        removeInputEvent() {
          if (this.querySelector('#CollectionFiltersForm')) {
            this.querySelector('#CollectionFiltersForm').removeEventListener(
              'input',
              this.debouncedOnSubmit.bind(this)
            );
          }
        }

        initFilter() {
          const _this = this;
          const $showFilter = $(this).find('.showFilter');
          const $filterWrapper = $(_this).find('.filter_wrapper');
          $showFilter.on('click', function (event) {
            event.stopPropagation();
            if ($filterWrapper.hasClass('hidden')) {
              $(this).find('i').css('transform', 'rotate(270deg)');
              $filterWrapper.removeClass('hidden');
            } else {
              $(this).find('i').css('transform', 'rotate(90deg)');
              $filterWrapper.addClass('hidden');
            }
            if ($(window).width() <= 576) {
              window.litime.disableScroll();
            }
          });
          document.addEventListener('click', (e) => {
            // 如果点击的是filter_wrapper 包含其子元素，则不隐藏
            if (e.target.className === 'filter_wrapper' || $filterWrapper.find(e.target).length > 0) {
              return;
            }
            const $showFilter = $(this).find('.showFilter');
            $showFilter.find('i').css('transform', 'rotate(90deg)');
            $filterWrapper.addClass('hidden');
          });
        }

        initPcFilterItemEvent() {
          const _this = this;
          const $pcFilterItem = $(this).find('.pc_filter_item');
          $pcFilterItem.on('click', function (event) {
            if (event.target.tagName === 'INPUT') {
              return;
            }
            event.stopPropagation();
            if ($(this).find('input').prop('checked')) {
              $(this).find('input').prop('checked', false);
            } else {
              $(this).find('input').prop('checked', true);
            }
            // _this.onSubmitHandler();
          });
        }

        initMobileFilterItemEvent() {
          const _this = this;
          const $mobileFilterItem = $(this).find('.mobile_filter_item');
          $mobileFilterItem.on('click', function (event) {
            event.stopPropagation();
            if (event.target.tagName === 'INPUT') {
              return;
            }
            if ($(this).find('input').prop('disabled')) {
              return;
            }
            if ($(this).find('input').prop('checked')) {
              $(this).find('input').prop('checked', false);
            } else {
              $(this).find('input').prop('checked', true);
            }
          });
          const $filterReset = $(_this).find('.filter_reset');
          $filterReset.on('click', function () {
            const mobileFilterForm = $(_this).find('#mobileFilterForm');
            const input = mobileFilterForm.find('input');
            input.each(function () {
              if ($(this).is(':visible')) {
                $(this).prop('checked', false);
              }
            });
            _this.onSubmitHandler('mobileFilterForm');
            $(_this).find('.filter_wrapper').addClass('hidden');
          });

          const $filterApply = $(_this).find('.filter_apply');
          $filterApply.on('click', function () {
            _this.onSubmitHandler('mobileFilterForm');
            $(_this).find('.filter_wrapper').addClass('hidden');
            window.litime.enableScroll();
          });
          const $filterClose = $(_this).find('.mobile_filter_close');
          $filterClose.on('click', function () {
            $(_this).find('.filter_wrapper').addClass('hidden');
            window.litime.enableScroll();
          });
        }

        initShowMore() {
          const _this = this;
          const $showMore = $(_this).find('[data-show-more]');
          let height;
          let newHeight;
          let lastFilterLabel = '';
          $showMore.on('click', function () {
            const filterLabel = $(this).data('show-more');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            $(_this).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
            // 记录当前filter_item_wrapper的高度
            $filterItemWrapper.height('auto');
            const filterItemWrapperHeight = $filterItemWrapper.height();
            height = filterItemWrapperHeight;
            $(_this).find(`[data-filter-more="${filterLabel}"]`).removeClass('hidden');
            $(_this).find(`[data-show-less="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            $(_this).find(`[data-show-more="${filterLabel}"]`).addClass('hidden');
            if (newHeight && lastFilterLabel === filterLabel) {
              $filterItemWrapper.height(height);
              setTimeout(() => {
                $filterItemWrapper.height(newHeight);
              }, 50);
            } else {
              lastFilterLabel = filterLabel;
              // 记录最新filter_item_wrapper的高度
              $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              newHeight = newFilterItemWrapperHeight;
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
              }, 50);
            }
          });
          const $showLess = $(_this).find('[data-show-less]');
          $showLess.on('click', function () {
            const filterLabel = $(this).data('show-less');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            const filterItemWrapperHeight = $filterItemWrapper.height();
            $(_this).find(`[data-show-less="${filterLabel}"]`).addClass('hidden');
            $(_this).find(`[data-show-more="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            // 记录最新filter_item_wrapper的高度
            // $filterItemWrapper.height(newHeight);
            setTimeout(() => {
              $filterItemWrapper.height(height);
            }, 50);
          });
        }

        initDrawer() {
          const _this = this;
          const $drawer = $(_this).find('.filter_item_drawer');
          $drawer.on('click', function () {
            const filterLabel = $(this).data('filter-drawer');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            let $filterOpen = $(this).data('filter-open');
            if ($filterOpen) {
              // 实现收起
              // 修改data-filter-open为false
              $(this).data('filter-open', false);
              // 获取data-show-more
              $(_this).find(`[data-show-more="${filterLabel}"]`).css('opacity', 0);
              // 获取data-show-less
              $(_this).find(`[data-show-less="${filterLabel}"]`).css('opacity', 0);

              $(this).find('.filter_item_add').removeClass('hidden');
              $(this).find('.filter_item_remove').addClass('hidden');
              const filterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              setTimeout(() => {
                $filterItemWrapper.height(0);
                const showMoreWrapper = $(_this).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.addClass('hidden');
              }, 50);
            } else {
              // 实现展开
              // 修改data-filter-open为true
              $(this).data('filter-open', true);
              // 获取data-show-more
              $(_this).find(`[data-show-more="${filterLabel}"]`).css('opacity', 1).removeClass('hidden');
              // 获取data-show-less
              $(_this).find(`[data-show-less="${filterLabel}"]`).css('opacity', 1).addClass('hidden');
              $(this).find('.filter_item_add').addClass('hidden');
              $(this).find('.filter_item_remove').removeClass('hidden');
              $(_this).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
              $filterItemWrapper.height('auto');
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(0);
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
                const showMoreWrapper = $(_this).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.removeClass('hidden');
              }, 50);
            }
          });
        }

        init() {
          const _this = this;
          const displayMode = this.getAttribute('data-display-mode');

          // 只有在 slid 模式下才初始化 Swiper
          if (displayMode === 'slid') {
            const $mySwiper = this.querySelector('.scenario-rv-product_swiper');
            const $next = this.querySelector('.scenario-rv-product_next');
            const $prev = this.querySelector('.scenario-rv-product_prev');
            const $pagination = this.querySelector('.scenario-rv-product_swiper-pagination');
            const $scrollbarDom = this.querySelector('.scenario-rv-product-scrollbar');

            if ($mySwiper) {
              this.swiper = new Swiper($mySwiper, {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 24,
                breakpoints: {
                  1201: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                  },
                  961: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    spaceBetween: 20,
                  },
                  769: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 16,
                  },
                  385: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                  },
                  0: {
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    spaceBetween: 16,
                  },
                },
                scrollbar: {
                  el: $scrollbarDom,
                  draggable: true,
                },
                on: {
                  progress: function (swiper, progress) {
                    if (progress == 0) {
                      $($next).removeClass('hidden').addClass('flex');
                      $($prev).removeClass('flex').addClass('hidden');
                    } else if (progress > 0 && progress < 1) {
                      $($next).removeClass('hidden').addClass('flex');
                      $($prev).removeClass('hidden').addClass('flex');
                    } else if (progress == 1) {
                      $($next).removeClass('flex').addClass('hidden');
                      $($prev).removeClass('hidden').addClass('flex');
                    } else {
                      $($prev).addClass('hidden');
                    }
                  },
                },
                navigation: {
                  nextEl: $next,
                  prevEl: $prev,
                },
                pagination: {
                  el: $pagination,
                  bulletClass: 'scenario-rv-product_bullet',
                  bulletActiveClass: 'scenario-rv-product_active',
                },
              });
            }
          }

          this.debouncedOnSubmit = (event) => {
            event.preventDefault();
            this.onSubmitHandler();
          };
          // if (this.querySelector('#CollectionFiltersForm')) {
          //   this.querySelector('#CollectionFiltersForm').addEventListener('input', this.debouncedOnSubmit.bind(this));
          // }

          const $button = $(this).find('.global-tab-item');

          $button.on('click', function () {
            // 获取data-tab-value
            const $dataValue = $(this).data('tab-value');
            // 获取data-form-value
            const $allDataFormValue = $(_this).find(`[data-form-value`);
            const $dataFormValue = $(_this).find(`[data-form-value="${$dataValue}"]`);
            const CollectionFiltersForm = $(_this).find('#CollectionFiltersForm');
            const input = CollectionFiltersForm.find('input');
            input.each(function () {
              $(this).prop('checked', false);
            });
            $allDataFormValue.find('input').prop('checked', false);
            $dataFormValue.find('input').prop('checked', true);
            _this.onSubmitHandler();
          });

          // 获取data-sortby的元素
          let dataSortbys = $(this.querySelectorAll('[data-sortby]'));
          dataSortbys.on('click', function (event) {
            // 获取data-sortby的值
            let dataSortbyValue = $(this).data('sortby');
            // 获取地址栏所有参数
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('sort_by', dataSortbyValue);
            const url = window.location.pathname + '?' + urlParams.toString();
            window.history.pushState({}, '', url);
            _this.renderSectionFromFetch(url);
          });

          // 获取data-remove-url的元素
          let dataRemoveUrls = $(this.querySelectorAll('[data-remove-url]'));
          dataRemoveUrls.on('click', function () {
            const dataRemoveUrlValue = $(this).data('remove-url');
            window.history.pushState({}, '', dataRemoveUrlValue);
            _this.renderSectionFromFetch(dataRemoveUrlValue);
          });

          const $filterReset = $(_this).find('.filter-pc_reset');
          $filterReset.on('click', function () {
            const CollectionFiltersForm = $(_this).find('#CollectionFiltersForm');
            const input = CollectionFiltersForm.find('input');
            input.each(function () {
              if ($(this).is(':visible')) {
                $(this).prop('checked', false);
              }
            });
            _this.onSubmitHandler('CollectionFiltersForm');
            $(_this).find('.filter_wrapper').addClass('hidden');
          });

          const $filterApply = $(_this).find('.filter-pc_apply');
          $filterApply.on('click', function () {
            _this.onSubmitHandler('CollectionFiltersForm');
            $(_this).find('.filter_wrapper').addClass('hidden');
            window.litime.enableScroll();
          });
        }

        /**
         * 获取响应式网格配置
         * 根据屏幕宽度返回每行显示数量和每次加载数量
         */
        _getGridStep() {
          const w = window.innerWidth;
          const pcRows = parseInt(this.getAttribute('data-pc-count') || '1', 10);
          const padRows = parseInt(this.getAttribute('data-pad-count') || '1', 10);
          const smallPadRows = parseInt(this.getAttribute('data-small-pad-count') || '1', 10);
          const mobileRows = parseInt(this.getAttribute('data-mobile-count') || '1', 10);

          if (w >= 1201) {
            // PC端：4列，每次+4个
            return { perRow: 4, step: 4, init: pcRows * 4 };
          } else if (w >= 961) {
            // 平板端：3列，每次+3个
            return { perRow: 3, step: 3, init: padRows * 3 };
          } else if (w >= 577) {
            // 小平板端：2列，每次+4个
            return { perRow: 2, step: 4, init: smallPadRows * 2 };
          } else {
            // 手机端：1列，每次+4个
            return { perRow: 1, step: 4, init: mobileRows * 1 };
          }
        }

        /**
         * 初始化产品网格功能
         * 处理 down 模式下的响应式显示和点击加载更多
         */
        initProductGrid() {
          const displayMode = this.getAttribute('data-display-mode');

          // 只有在 down 模式下才初始化产品网格
          if (displayMode !== 'down') {
            return;
          }

          const grid = this.querySelector('.grid');
          const more = this.querySelector('.scenario-rv-product__grid_more');

          if (!grid || !more) {
            return;
          }

          const { step, init } = this._getGridStep();
          const total = grid.querySelectorAll('.scenario-rv-product__grid_item').length;
          const initVisible = Math.min(init, total);

          grid.dataset.visibleCount = String(initVisible);

          // 确保初始状态正确，移除可能冲突的响应式类名
          this._ensureInitialVisibility(grid, initVisible);

          this._updateMoreButtonVisibility(grid, more);

          // 移除之前的事件监听器，避免重复绑定
          if (this._handleMoreClick) {
            more.removeEventListener('click', this._handleMoreClick);
          }

          // 绑定点击事件
          this._handleMoreClick = (e) => {
            e.preventDefault();
            const { step } = this._getGridStep();
            const total = grid.querySelectorAll('.scenario-rv-product__grid_item').length;
            const current = parseInt(grid.dataset.visibleCount || '0', 10) || 0;
            const next = Math.min(current + step, total);
            grid.dataset.visibleCount = String(next);
            this._applyGridVisibility(grid, more, true);
          };

          more.addEventListener('click', this._handleMoreClick);
        }

        /**
         * 确保初始可见性状态正确
         * @param {HTMLElement} grid - 网格容器
         * @param {number} initVisible - 初始可见数量
         */
        _ensureInitialVisibility(grid, initVisible) {
          const items = Array.from(grid.querySelectorAll('.scenario-rv-product__grid_item'));

          items.forEach((el, idx) => {
            if (idx < initVisible) {
              // 确保应该显示的元素没有隐藏类
              el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
            }
          });
        }

        /**
         * 更新"更多"按钮的可见性
         * @param {HTMLElement} grid - 网格容器
         * @param {HTMLElement} more - 更多按钮
         */
        _updateMoreButtonVisibility(grid, more) {
          const total = grid.querySelectorAll('.scenario-rv-product__grid_item').length;
          const visible = parseInt(grid.dataset.visibleCount || '0', 10) || 0;

          // 控制按钮显隐
          if (visible >= total) {
            more.classList.add('hidden');
          } else {
            more.classList.remove('hidden');
          }
        }

        /**
         * 应用网格可见性
         * @param {HTMLElement} grid - 网格容器
         * @param {HTMLElement} more - 更多按钮
         * @param {boolean} smooth - 是否平滑过渡
         */
        _applyGridVisibility(grid, more, smooth) {
          const items = Array.from(grid.querySelectorAll('.scenario-rv-product__grid_item'));
          const total = items.length;
          const visible = Math.min(parseInt(grid.dataset.visibleCount || '0', 10) || 0, total);

          items.forEach((el, idx) => {
            if (idx < visible) {
              // 显示元素：移除所有隐藏类，包括响应式类
              el.classList.remove('hidden', 'max-lg:hidden', 'max-md:hidden');
            } else {
              // 隐藏元素：添加基础hidden类
              el.classList.add('hidden');
            }
          });

          // 控制按钮显隐
          if (visible >= total) {
            more.classList.add('hidden');
          } else {
            more.classList.remove('hidden');
          }
        }
      }
    );
  }
});
